import { StrMarker } from "./strMarker";

export class SearchResult {
    objectIndex : string;
    objectField : string;
    strMarker : StrMarker;

    constructor(objectIndex : string, objectField :string, strMarker?: StrMarker){
        this.objectIndex = objectIndex;
        this.objectField = objectField;
        this.strMarker = strMarker;
    }
}
